import React, {Component} from "react";

import TournamentLeaderboardEntry from "./tournament-leaderboard-entry.js";
import TournamentLeaderboardTab from "./tournament-leaderboard-tab.js";

import {getTournamentLeaderboardEntries} from "../../../modules/tournament.js";

require("./tournament-leaderboard.css");
class TournamentLeaderboard extends Component {
    constructor(props) {
        super(props);

        this.PAGE_SIZE = 10;

        this.LEADERBOARD_TYPES = {
            PLAYER: 1,
            ORGANIZATION: 2,
            BUSINESS_GROUP: 3
        };

        this.LEADERBOARD_TYPE_TEXTS = {
            PLAYER: "All \n Players",
            ORGANIZATION: "My Facility \n Leaderboard",
            BUSINESS_GROUP: "Tournament \n Leaderboard"
        };

        this.state = {
            leaderboard_titles: [],
            leaderboard_entries: [],
            page: 0,
            total_pages: 0,
            leaderboard_type: this.LEADERBOARD_TYPES.BUSINESS_GROUP,
            loading: false,
            daily: false
        };
    }

    async componentDidMount() {
        let {leaderboard_type} = this.state;
        this.changeTab(leaderboard_type);
        await this.loadLeaderboard(0, leaderboard_type);
    }

    async changeTab(type) {
        this.setState({page: 0, leaderboard_type: type});
        

        console.log("Changing tab!");
        let titles = [];
        switch (type) {
            case this.LEADERBOARD_TYPES.PLAYER:
                titles = [
                    {
                        field: "rank",
                        text: "Rank"
                    },
                    {
                        field: "organization_name",
                        text: "Facility"
                    },
                    {
                        field: "player_name",
                        text: "Player Name"
                    },
                    {
                        field: "score",
                        text: "Score"
                    }
                ];
                break;
            case this.LEADERBOARD_TYPES.ORGANIZATION:
                titles = [
                    {
                        field: "rank",
                        text: "Rank"
                    },
                    {
                        field: "player_name",
                        text: "Player Name"
                    },
                    {
                        field: "score",
                        text: "Score"
                    }
                ];
                break;
            case this.LEADERBOARD_TYPES.BUSINESS_GROUP:
                titles = [
                    {
                        field: "rank",
                        text: "Rank"
                    },
                    {
                        field: "organization_name",
                        text: "Facility"
                    },
                    {
                        field: "score",
                        text: "Score"
                    }
                ];
                break;
            default:
                titles = [];
                break;
        }
        this.setState({leaderboard_titles: titles});
        await this.loadLeaderboard(0, type)

    }

    nextPage() {
        let {page, total_pages, leaderboard_type} = this.state;

        if (page === total_pages) {
            return;
        }
        let newPage = page + 1;
        this.setState({page: newPage});

        this.loadLeaderboard(newPage, leaderboard_type);
    }

    prevPage() {
        let {page, leaderboard_type} = this.state;

        if (page === 0) {
            return;
        }
        let newPage = page - 1;
        this.setState({page: newPage});
        this.loadLeaderboard(newPage, leaderboard_type);
    }

    async loadLeaderboard(page, type, newDaily) {

        if (typeof newDaily === "undefined") {
            newDaily = -1;
        }
        let {token} = this.props;
        let {tournament_data} = this.props;

        let {daily} = this.state;

        if (newDaily !== -1) {
            daily = newDaily;
        }
        this.setState({leaderboard_type: type, page: page});
        this.setState({loading: true});

        let leaderboardEntries = {success:true, entries:[], count:0}
        if(tournament_data.id){
            const entriesResponse = await getTournamentLeaderboardEntries(tournament_data.id, type, page, daily, token);
            leaderboardEntries = entriesResponse.data
        }
        

        if (leaderboardEntries.success) {
            var entries = leaderboardEntries.entries;
            var totalPages = Math.ceil(leaderboardEntries.count / this.PAGE_SIZE);
            this.setState({leaderboard_entries: entries, total_pages: totalPages});
        }

        this.setState({loading: false});
    }

    printTitles() {
        let {leaderboard_titles} = this.state;
        return leaderboard_titles.map(function (title, i) {
            return <th key={i}>{title.text}</th>
        });
    }

    printEntries() {
        let {page, leaderboard_titles, leaderboard_entries} = this.state;  
        let i = (page * 10) + 1;
        return leaderboard_entries.map(function (entryData) {
            console.log(entryData);
            entryData.rank = i;
            i++;
            return <TournamentLeaderboardEntry titles={leaderboard_titles} entry={entryData} />
        });
    }

    printTabs() {
        let {leaderboard_type} = this.state;

        let tabs = [];

        tabs.push(<TournamentLeaderboardTab key={"1"} type={this.LEADERBOARD_TYPES.BUSINESS_GROUP} current_type={leaderboard_type} text={this.LEADERBOARD_TYPE_TEXTS.BUSINESS_GROUP} click_func={this.changeTab.bind(this)} />);
        tabs.push(<TournamentLeaderboardTab key={"2"} type={this.LEADERBOARD_TYPES.ORGANIZATION} current_type={leaderboard_type} text={this.LEADERBOARD_TYPE_TEXTS.ORGANIZATION} click_func={this.changeTab.bind(this)} />);
        tabs.push(<TournamentLeaderboardTab key={"3"} type={this.LEADERBOARD_TYPES.PLAYER} current_type={leaderboard_type} text={this.LEADERBOARD_TYPE_TEXTS.PLAYER} click_func={this.changeTab.bind(this)} />);

        return tabs;
    }

    updateDailyCheckbox() {
        let {daily, leaderboard_type} = this.state;

        daily = !daily;
        this.setState({page: 0, daily: daily});

        this.loadLeaderboard(0, leaderboard_type, daily);
    }

    render() {
        let {page, total_pages, loading} = this.state;

        page = page + 1;

        return (
            <div className='tournament_leaderboard_container'>
                <div id='tournament_leaderboard_tabs'>
                    {this.printTabs()}
                </div>
                <div className='tournament_leaderboard_table_container'>
                {!loading && <table className='tournament_leaderboard'>
                                <thead className='tournament_leaderboard_head'>
                                    <tr className='tournament_leaderboard_header_row'>
                                        {this.printTitles()}
                                    </tr>
                                </thead>
                                <tbody className='tournament_leaderboard_body'>
                                    {this.printEntries()}
                                </tbody>
                            </table>
                }
                </div>
                <div id='tournament_leaderboard_pagination'>
                    <div id='tournament_leaderboard_page_indicator'>{page + "/" + total_pages}</div>
                    <div id='tournament_leaderboard_pagination_buttons'>
                        {page > 1 && <span onClick={this.prevPage.bind(this)} className='tournament_leaderboard_pagination_button left'>Prev Page</span>}
                        {page === 1 && <span className='tournament_leaderboard_pagination_button left inactive'>Prev Page</span>}
                        <div id='daily_leaderboard_checkbox_container'>
                            <input type='checkbox' onChange={this.updateDailyCheckbox.bind(this)} name='daily_leaderboard_checkbox'/>
                            <label htmlFor='daily_leaderboard_checkbox' id='daily_leaderboard_checkbox_label'>Show Today's Leaderboard</label>
                        </div>
                        {page < total_pages && <span onClick={this.nextPage.bind(this)} className='tournament_leaderboard_pagination_button right'>Next Page</span>}
                        {page >= total_pages && <span className='tournament_leaderboard_pagination_button right inactive'>Next Page</span>}
                    </div>
                </div>
            </div>
        );
        
    }
}

export default TournamentLeaderboard;


// WEBPACK FOOTER //
// ./src/components/containers/tournaments/tournament-leaderboard.js